import { useEffect, useState, useMemo } from "react";
import { isEmpty } from "lodash";
import useScrollToItem from "../../components/Scroll";
import useLimitHandler from "../Favourite/useLimitHandler";
import { useTranslation } from "react-i18next";

export const useFavMatchOddsLogic = ({
  object,
  betSlipObject,
  showBetDialog,
  user,
  setShowBetDialog,
  setBetSlipObject,
  setToastObject,
  defaultStakeLimit,
  profileData,
  setLimit,
  position,
  totalMatched,
}) => {
  const { t } = useTranslation();
  const [runner, setRunner] = useState([]);
  const [localLimit, setLocalLimit] = useState({});

  const marketName = object?.market;
  const typeGame = "betFaire";

  /** ---------- Sync runners when object changes ---------- **/
  useEffect(() => {
    if (!isEmpty(object)) {
      setRunner(object?.runners || []);
    }
  }, [object]);

  /** ---------- Sync positions ---------- **/
  useEffect(() => {
    if (position?.length > 0) {
      setRunner((prev) =>
        prev?.map((res) => {
          const found = position?.find(
            (obj) => obj?.selectionId == res?.SelectionId
          );
          return found ? { ...res, position: found?.position } : res;
        })
      );
    }
  }, [position]);

  /** ---------- Limits ---------- **/
  const getLimit = useLimitHandler({
    profileData,
    object,
    marketName,
    defaultStakeLimit,
    totalMatched,
    typeGame,
  });

  useEffect(() => {
    setLocalLimit(getLimit);
  }, [getLimit]);

  /** ---------- BetSlip Effect ---------- **/
  useEffect(() => {
    if (
      !isEmpty(betSlipObject) &&
      betSlipObject?.playType == "betFaire" &&
      showBetDialog
    ) {
      handelBetFairPositions(betSlipObject);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [betSlipObject, showBetDialog]);

  /** ---------- Helpers ---------- **/
  const scrollToItem = useScrollToItem("#header");

  const handelChange = (odds, type, team, item, e) => {
    if (!isEmpty(user)) {
      if (odds?.rt > 0) {
        setShowBetDialog(true);
        scrollToItem(e.currentTarget);

        const obj = {
          odds: odds?.rt,
          teamName: team,
          betType: type,
          playType: "betFaire",
          newMarketId: object?.marketId,
          object: {
            ...item,
            ...odds,
            teamName: team,
            eventId: object?.eventId,
            marketId: object?.marketId,
            newMarketId: object?.marketId,
          },
        };

        setLimit(localLimit);
        setBetSlipObject((prev) => ({ ...prev, ...obj }));
      }
    } else {
      setToastObject({
        type: "warning",
        title: t("Warning"),
        message: t("PleaseLoginToPlaceBet"),
        status: true,
      });
    }
  };

  const handelBetFairPositions = (slipObj) => {
    let selectionsTemp = runner?.map((item) => ({
      ...item,
      position: item?.position || 0,
      newPosition: item?.newPosition || 0,
    }));

    if (betSlipObject?.bidPrice > 0) {
      const { ri } = slipObj?.object || {};
      if (slipObj?.object?.ib) {
        // Back Bet
        const backProfit = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;
        const backLoss = betSlipObject?.bidPrice;

        selectionsTemp = selectionsTemp?.map((rl) =>
          rl.SelectionId === ri
            ? { ...rl, newPosition: Number(rl.position) + backProfit }
            : { ...rl, newPosition: Number(rl.position) - backLoss }
        );
      } else {
        // Lay Bet
        const backProfit = betSlipObject?.bidPrice;
        const backLoss = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;

        selectionsTemp = selectionsTemp?.map((rl) =>
          rl.SelectionId === ri
            ? { ...rl, newPosition: Number(rl.position) - backLoss }
            : { ...rl, newPosition: Number(rl.position) + backProfit }
        );
      }
    }

    setRunner(selectionsTemp);
  };
  function isRtValid(obj, limit) {
    const { rt } = obj;
    if (rt === undefined || rt === null || rt === "" || rt === 0) return true;
    if (typeof rt === "number" && limit !== undefined) {
      return rt >= limit?.oddsLimit;
    }
    return false;
  }
  function checkArrays(arr1, arr2, limit) {
    return [...arr1, ...arr2].every((obj) => isRtValid(obj, limit));
  }
  return {
    runner,
    handelChange,
    localLimit,
    checkArrays,
  };
};
